import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// services
import { AuthService } from 'src/app/core/services/user/auth.service';
import { AlertService } from 'src/app/core/services/alert/alert.service';

//enums
import { LAYOUTS_TYPE } from 'src/app/core/enums/layouts/layouts-types';

export const IsAppOwner: CanActivateFn = (route, state) => {
  
  /**
   * init
   */
  const _router = inject(Router);
  const _auth = inject(AuthService);
  const _alert = inject(AlertService);

  // ES6 Destruction
  const {  value: { appOwner } } = _auth.userInfo;

  /**
   * enableAddAds
   */
  if (appOwner == true) return true;

  /**
   * handler alert
   */
  _alert.show({
    type: LAYOUTS_TYPE.alertInfo,
    callback: () => _alert.hide(),
    msg: 'ليس لديك صلاحية الوصول!',
  })

  /**
   * 
   */
  _router.navigate(['/']);

  /**
   * 
   */
  return false;

};
